<template>
  <v-row>
    <v-col cols="12" offset-lg="1" lg="10">
      <v-breadcrumbs :items="breadcrumbs" divider=">" class="pl-1 pb-3" />
      <v-card>
        <v-card-title class="theme">
          <v-icon class="white--text">waves</v-icon>
          <span class="headline ml-2 white--text">Workflow status</span>
          <v-spacer />
        </v-card-title>
        <v-card-text
          style="margin-top: -0.5rem; margin-bottom: -1rem"
          class="mx-3"
        >
          <v-row class="mt-3 mb-n5 ml-n2 mr-5">
            <v-col cols="12" md="4">
              <v-autocomplete
                label="Status"
                :items="['Active', 'Completed']"
                item-text="name"
                item-value="name"
                v-model="searchWorkflows.status"
                persistent-hint
                clearable
                outlined
                dense
                @change="getWorkflows()"
              ></v-autocomplete>
            </v-col>
            <v-spacer />
            <div class="text-right">
              <v-btn
                class="mt-3 action rounded-sm white--text"
                @click="completeTasks"
                :disabled="selected.length === 0"
                depressed
                >Mark as complete</v-btn
              >
            </div>
          </v-row>
        </v-card-text>
        <v-list>
          <template>
            <v-list-item class="mx-7" outlined>
              <v-list-item-subtitle>Name</v-list-item-subtitle>
              <v-list-item-subtitle>Type</v-list-item-subtitle>
              <v-list-item-subtitle>For</v-list-item-subtitle>
              <v-list-item-subtitle class="mr-8">Status</v-list-item-subtitle>
            </v-list-item>
          </template>
          <v-divider />
          <v-list-group
            :value="false"
            v-for="(item, i) in workflows"
            v-bind:key="i"
            @click="getTasks(item)"
          >
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-title>{{ item.workflow_name }}</v-list-item-title>
                <v-list-item-title>{{ item.type }}</v-list-item-title>
                <v-list-item-title>{{ item.for_name }}</v-list-item-title>
                <v-list-item-title
                  v-if="item.status == 'Completed'"
                  class="success--text ml-8"
                  >{{ item.status }}</v-list-item-title
                >
                <v-list-item-title v-else class="theme-text ml-8">{{
                  item.status
                }}</v-list-item-title>
              </v-list-item>
            </template>
            <v-list-item class="pl-16 grey lighten-5">
              <v-list-item-subtitle>Task name</v-list-item-subtitle>
              <v-list-item-subtitle>Assignee</v-list-item-subtitle>
              <v-list-item-subtitle>Status</v-list-item-subtitle>
              <v-list-item-subtitle> Date </v-list-item-subtitle>
            </v-list-item>

            <v-list-item v-for="(item, i) in tasks" v-bind:key="i">
              <template>
                <v-list-item-action>
                  <v-checkbox
                    v-if="item.done"
                    :input-value="true"
                    value
                    disabled
                  ></v-checkbox>
                  <v-checkbox
                    v-else
                    :value="item"
                    :disabled="hasAccess(item)"
                    v-model="selected"
                  ></v-checkbox>
                </v-list-item-action>

                <v-list-item-subtitle>{{ item.name }}</v-list-item-subtitle>
                <v-list-item-subtitle>{{ item.to_name }}</v-list-item-subtitle>
                <v-list-item-subtitle v-if="item.done" class="success--text"
                  >Done</v-list-item-subtitle
                >
                <v-list-item-subtitle v-else class="theme-text"
                  >Pending</v-list-item-subtitle
                >
                <v-list-item-subtitle>{{
                  item.assigned_date
                }}</v-list-item-subtitle>
              </template>
            </v-list-item>
          </v-list-group>
        </v-list>
        <template>
          <div class="text-center mt-5 pb-5">
            <v-btn
              fab
              small
              color="theme white--text mb-5"
              depressed
              @click="previous"
              :disabled="pagination.page <= 0"
            >
              <v-icon small>navigate_before</v-icon>
            </v-btn>
            <span>
              <v-btn text :disabled="true">{{ pagination.page + 1 }}</v-btn>
            </span>
            <v-btn
              fab
              small
              depressed
              color="theme white--text mb-5"
              @click="next"
              :disabled="pagination.disableNext"
            >
              <v-icon small>navigate_next</v-icon>
            </v-btn>
          </div>
        </template>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";

import { Actions } from "@/views/actions";
import { Breadcrumbs } from "@/views/breadcrumbs";
import { Component } from "@/views/component";

export default {
  name: Component.Protected.Company.WorkflowToDos.List,
  computed: {
    ...mapGetters(["userInfo"]),
  },
  data: () => ({
    breadcrumbs: Breadcrumbs.WorkflowToDos.List,
    //tableHeaders: TableHeaders.Announcement.List,
    search: { limit: 10, offset: 0, workflow_id: 0, for: 0 },
    searchWorkflows: { limit: 10, offset: 0, status: "Active" },
    pagination: { disableNext: true, page: 0 },
    workflows: [],
    tasks: [],
    selected: [],
  }),
  methods: {
    next() {
      if (this.pagination.page < 0) {
        this.pagination.page = 0;
        this.searchWorkflows.offset = 0;
      } else if (this.workflows.length <= this.searchWorkflows.limit) {
        this.pagination.page++;
        this.searchWorkflows.offset =
          this.searchWorkflows.limit * this.pagination.page;
        this.getWorkflows();
      }
    },
    previous() {
      this.pagination.page--;
      if (this.pagination.page < 0) {
        this.pagination.page = 0;
        this.searchWorkflows.offset = 0;
      } else {
        this.searchWorkflows.offset =
          this.searchWorkflows.limit * this.pagination.page;
        this.getWorkflows();
      }
    },
    hasAccess(item) {
      let disabled = false;
      item.to !== parseInt(this.userInfo.userID)
        ? this.userInfo.role != "HR" && this.userInfo.role != "Manager"
          ? (disabled = true)
          : (disabled = false)
        : (disabled = false);
      return disabled;
    },
    getWorkflows() {
      this.$store
        .dispatch(Actions.Workflow.GetWorkflowToDos, this.searchWorkflows)
        .then((r) => {
          let len = r.data.length;
          if ((len < this.searchWorkflows.limit && len > 0) || len === 0) {
            this.pagination.disableNext = true;
          } else if (len === this.searchWorkflows.limit) {
            this.pagination.disableNext = false;
          }
          this.workflows = r.data;
        });
    },
    getTasks(item) {
      this.search.workflow_id = item.workflow_id;
      this.search.for = item.for_id;
      this.$store.dispatch(Actions.Tasks.Find, this.search).then((r) => {
        if (r.status === 200) {
          this.selected = [];
          this.tasks = { ...r.data };
        }
      });
    },
    completeTasks() {
      const details = [];
      this.selected.forEach((element) => {
        details.push({
          workflow_id: element.workflow_id,
          for_id: element.for,
          type: element.type,
          workflow_todo_id: element.workflow_todo_id,
          for_name: element.for_name,
        });
      });
      const data = {
        tasks: this.selected.map((x) => x.id),
        details: details,
      };

      if (this.selected.length > 0) {
        this.$store.dispatch(Actions.Tasks.Complete, data).then((r) => {
          if (r.status === 200) {
            this.getTasks(details[0]);
            this.selected = [];
          }
        });
      }
    },
    setup() {
      this.getWorkflows();
    },
  },
  created() {
    if (this.userInfo.role) {
      this.setup();
    } else {
      this.$store.dispatch(Actions.Firebase.UserInfo).then(() => this.setup());
    }
  },
};
</script>